import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    loadingStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
}));
